import { createApi } from "@reduxjs/toolkit/query/react";
import { baseAuthQuery } from "../base/baseApi";
import { ApiResponse } from "../base/apiResponse";
import { SubjectResponse } from "../../models/dtos";

export const subjectsApi = createApi({
  reducerPath: "subjectsApi",
  baseQuery: baseAuthQuery("Subjects"),
  tagTypes: ["Subject"],
  endpoints: (builder) => ({
    getSubjects: builder.query<ApiResponse<SubjectResponse[]>, void>({
      query: () => "",
      providesTags: ["Subject"],
    }),
    getSubjectsBySpecialityId: builder.query<ApiResponse<SubjectResponse[]>, number>({
      query: (specialityId) => ({ url: `GetBySpecialityId/${specialityId}` }),
      providesTags: ["Subject"],
    }),
    getSubjectsByFacultyOfSpeciality: builder.query<ApiResponse<SubjectResponse[]>, number>({
      query: (specialityId) => ({ url: `GetByFacultyOfSpeciality/${specialityId}` }),
      providesTags: ["Subject"],
    }),
    getSubjectById: builder.query<ApiResponse<SubjectResponse>, number>({
      query: (id) => ({ url: `/${id}` }),
      providesTags: ["Subject"],
    }),
    updateSubject: builder.mutation<ApiResponse<SubjectResponse>, Partial<SubjectResponse>>({
      query: (body) => ({ url: "CreateOrUpdate", method: "POST", body }),
      invalidatesTags: ["Subject"],
    }),
    deleteSubject: builder.mutation<ApiResponse<boolean>, number>({
      query: (id) => ({ url: `Delete/${id}`, method: "GET" }),
      invalidatesTags: ["Subject"],
    }),
  }),
});
